import { put, call } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import { startSubmit, stopSubmit, reset } from 'redux-form'
import * as colors from 'material-ui/styles/colors';

import moment from 'moment'

import * as commons from '../commons'
import * as actions from '../actions'


export function* handleYosanInit(action) {

  const {id} = action.payload

  yield put(reset(`yosanForm`))

  yield put(actions.reducerAppLoading(true))

  let yosanResult = {}
  if (id) {
    let res = yield call(commons.get2, `/bg/yosan/${id}`)
    const check = yield call(errorCheck, res)
    if (!res) {
      return
    }
    yosanResult = res.result
  }

  const kenmeiRes = yield call(commons.get2, `/bg/master/kenmei`)
  const kenmeiResCheck = yield call(errorCheck, kenmeiRes)
  if (!kenmeiResCheck) {
    return
  }

  const costRes = yield call(commons.get2, `/bg/master/cost?isOtherCost=1`)
  const costResCheck = yield call(errorCheck, costRes)
  if (!costResCheck) {
    return
  }

  const userRes = yield call(commons.get2, `/bg/master/user`)
  const userResCheck = yield call(errorCheck, userRes)
  if (!userResCheck) {
    return
  }

  let kenmeiNames = {
    kenmeiName: "ー",
    branchOfficeName: "ー",
    departmentName: "ー",
    customerName: "ー",
    constructionName: "ー",
    address: "ー",
  }

  if (yosanResult && kenmeiRes.result.list) {
    const kenmei = kenmeiRes.result.list.find(x => {
      return yosanResult.kenmeiCode === x.code
    })
    if (kenmei) {
     kenmeiNames = {
        kenmeiName: kenmei.name,
        branchOfficeName: kenmei.branchOfficeName,
        departmentName: kenmei.departmentName,
        customerName: kenmei.customerName,
        constructionName: kenmei.constructionName,
        address: kenmei.address,
      } 
    }
  }

  yield put(actions.reducerYosanInit(yosanResult,
    {
      kenmei: kenmeiRes.result.list,
      cost: costRes.result.list,
      user: userRes.result.list,
    },
    kenmeiNames
  ))

  yield call(delay, 200)

  yield put(actions.reducerAppLoading(false))

}

export function* handleYosanHistoryInit(action) {

    const {id, yearMonth} = action.payload

    yield put(reset(`yosanForm`))

    yield put(actions.reducerAppLoading(true))

    let yosanResult = {}
    if (id) {
        let res = yield call(commons.get2, `/bg/yosan_history/${id}/${yearMonth}`)
        const check = yield call(errorCheck, res)
        if (!res) {
            return
        }
        yosanResult = res.result
    }

    const kenmeiRes = yield call(commons.get2, `/bg/master/kenmei`)
    const kenmeiResCheck = yield call(errorCheck, kenmeiRes)
    if (!kenmeiResCheck) {
        return
    }

    const costRes = yield call(commons.get2, `/bg/master/cost?isOtherCost=1`)
    const costResCheck = yield call(errorCheck, costRes)
    if (!costResCheck) {
        return
    }

    const userRes = yield call(commons.get2, `/bg/master/user`)
    const userResCheck = yield call(errorCheck, userRes)
    if (!userResCheck) {
        return
    }

    let kenmeiNames = {
        kenmeiName: "ー",
        branchOfficeName: "ー",
        departmentName: "ー",
        customerName: "ー",
        constructionName: "ー",
        address: "ー",
    }

    if (yosanResult && kenmeiRes.result.list) {
        const kenmei = kenmeiRes.result.list.find(x => {
            return yosanResult.kenmeiCode === x.code
        })
        if (kenmei) {
            kenmeiNames = {
                kenmeiName: kenmei.name,
                branchOfficeName: kenmei.branchOfficeName,
                departmentName: kenmei.departmentName,
                customerName: kenmei.customerName,
                constructionName: kenmei.constructionName,
                address: kenmei.address,
            }
        }
    }

    yield put(actions.reducerYosanInit(yosanResult,
        {
            kenmei: kenmeiRes.result.list,
            cost: costRes.result.list,
            user: userRes.result.list,
        },
        kenmeiNames
    ))

    yield call(delay, 200)

    yield put(actions.reducerAppLoading(false))

}

const flatCost = (news, historys) => {
    let result = []
    if (news) {
        result = news.map(x => {
            return Object.assign({}, x, {
                createdAt: x.year ? moment([x.year, x.month - 1, 1]).format("YYYY/MM/DD HH:mm:ss") : null
            })
        })
    }
    historys && historys.forEach(x => {
        result = result.concat(x.data)
    })
    return result
}

export function* handleYosanFormRegist(action) {

  const {id, form, startDate, endDate} = action.payload
  
  yield put(startSubmit(`yosanForm`))
  yield put(actions.reducerAppLoading(true))

    let newForm = form
    if (!form.statusChange) {
        newForm = Object.assign({}, form, {
            startDate: moment(form.startDate).format('YYYY-MM-DD'),
            endDate: moment(form.endDate).format('YYYY-MM-DD'),
            materialCosts: flatCost(form.materialCosts, form.materialCostHistorys),
            outsourcingCosts: flatCost(form.outsourcingCosts, form.outsourcingCostHistorys),
            expenseCosts: flatCost(form.expenseCosts, form.expenseCostHistorys),
            startDateYYYYMM: startDate,
            endDateYYYYMM: endDate,
        })
    }

  let registRes;
  if (id) {
    registRes = yield call(commons.put2, `/bg/yosan/${id}`, newForm) 
  } else {
    registRes = yield call(commons.post2, `/bg/yosan`, newForm) 
  }

  const registCheck = yield call(errorCheck, registRes)
  if (!registCheck) {
    return
  }

  if (!id) {
    yield put(actions.reducerYosanListTest(1, {kenmeiCode: newForm.kenmeiCode}))
  }

  yield put(stopSubmit(`yosanForm`))
  yield put(reset(`yosanForm`))

  yield put(actions.reducerYosanStateClear())
  yield put(actions.reducerYosanSetTransition(true))
  yield put(actions.reducerSnackBar(true, '登録しました。', colors.green400))
  yield put(actions.reducerAppLoading(false))

}

export function* handleYosanFormDelete(action) {

    const {id, form} = action.payload

    yield put(startSubmit(`yosanForm`))
    yield put(actions.reducerAppLoading(true))

    const registRes = yield call(commons.delete2, `/bg/yosan/${id}`)

    const registCheck = yield call(errorCheck, registRes)
    if (!registCheck) {
        return
    }

    yield put(stopSubmit(`yosanForm`))
    yield put(reset(`yosanForm`))

    yield put(actions.reducerYosanSetTransition(true))
    yield put(actions.reducerSnackBar(true, '削除しました。', colors.green400))
    yield put(actions.reducerAppLoading(false))

}

function* errorCheck(res) {

  if (!res) {
    yield put(stopSubmit(`yosanForm`))
    yield put(actions.reducerSnackBar(true, '通信処理に失敗しました。', colors.red400))
    yield put(actions.reducerAppLoading(false))
    return
  }

  if (res.status && res.status == 401) {
    yield put(stopSubmit(`yosanForm`))
    yield put(actions.reducerSnackBar(true, 'セッションタイムアウト（30分）しました。', colors.red400))
    yield put(actions.reducerSetAuth({}, 9))
    yield put(actions.reducerAppLoading(false))
    return
  }

  if (res.fetchError || (res.status && res.status != 200)) {
    yield put(stopSubmit(`yosanForm`))
    yield put(actions.reducerSnackBar(true, '通信処理に失敗しました。', colors.red400))
    yield put(actions.reducerAppLoading(false))
    return false
  }
  
  if (res.error) {
    const {field, message} = res.error
    yield put(stopSubmit(`yosanForm`, { ...field }))
    yield put(actions.reducerSnackBar(true, message, colors.red400))
    yield put(actions.reducerAppLoading(false))
    return false
  }

  return true
}



// WEBPACK FOOTER //
// ./src/sagas/yosan.js